import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as Papa from 'papaparse';

import { API_URL, ENDPOINTS } from '../../constants/api';
import { CSVLink } from 'react-csv';
import { useParams } from 'react-router-dom';
import { notification } from 'antd';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import BlankHorizontalForm from '../../components/BlankHorizontalForm';
import { CURRENT_DATE, FIRST_DAY_OF_MONTH } from '../../constants';

const CSVUploader = () => {
  const [csvData, setCsvData] = useState(null);
  const [csvFile, setCsvFile] = useState(null); // store the actual file
  const [errorRecords, setErrorRecords] = useState([]);
  const [successRecords, setSuccessRecords] = useState([]);
  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);

  const token = getToken();
  const { route } = useParams();

  const [values, setValues] = useState([]);

  const [loading, setLoading] = useState(false);

  const [reportHeader, setReportHeader] = useState([]);
  const [reportFooter, setReportFooter] = useState([]);
  const [data, setData] = useState([]);

  const userId = decodeToken(token, 'id');
  const branchId = decodeToken(token, 'branch_id');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Fetch data from the server when the query changes
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/createform/${route}`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );
        console.log('response form:', response.data);
        setLink(response.data.link);
        setInputs(response.data.inputs);

        //console.log('response.data:', response.data);
        const initialState = {};

        response.data.inputs.map((input) => {
          if (input.type === 'file') {
            initialState[input.name] = null;
          } else if (
            input.type === 'dropdown' ||
            input.type === 'load-dropdown' ||
            input.type === 'enum-dropdown' ||
            input.type === 'group-dropdown'
          ) {
            // You can determine the selected value from the data
            const selectedOption = input?.dynamic_options?.find(
              (option) => option.selected === 'selected'
            );
            if (selectedOption) {
              initialState[input.name] = selectedOption.value;
            } else {
              initialState[input.name] = '%';
            }
          } else if (
            input.type === 'date' &&
            input.name === 'from' &&
            input.value === 'first_day_of_month'
          ) {
            initialState[input.name] = FIRST_DAY_OF_MONTH;
          } else if (
            (input.type === 'date' && input.name === 'to') ||
            input.type === 'today-date'
          ) {
            initialState[input.name] = CURRENT_DATE;
          } else if (input.type === 'hidden-user') {
            initialState[input.name] = userId;
          } else if (input.type === 'hidden-branch') {
            initialState[input.name] = branchId;
          } else {
            initialState[input.name] = input.value.trim();
          }
        });

        setValues(initialState);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleFileUploadChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setCsvFile(file); // save file for upload later

    // Optional: Preview CSV data
    Papa.parse(file, {
      complete: (result) => {
        setCsvData(result.data);
        // const updatedData = result.data.map((row) => ({
        //   ...row,
        //   ...values, // Merge with extra form data if needed
        // }));
        // setCsvData(updatedData);
      },
      header: true,
      skipEmptyLines: true,
    });
  };

  const handleUploadToServer = () => {
    if (!csvFile) {
      console.error('No file selected');
      return;
    }

    const formData = new FormData();
    formData.append('csv', csvFile);
    formData.append('table', link?.table_name);
    formData.append('columns', JSON.stringify(link?.columns)); // stringified if it's an object
    formData.append('values', JSON.stringify(values));
    const url = `${API_URL}/${ENDPOINTS.SYS}/upload-csv-file/${route}`;
    axios
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: token ? `Bearer ${token}` : '',
        },
      })
      .then((res) => {
        console.log('url:', url, 'res:', res.data);

        if (res.data.success === 0) {
          notification.error({ message: res.data.message });
        } else {
          setSuccessRecords(res.data.success);
          setErrorRecords(res.data.errors);
        }
      })
      .catch((err) => {
        console.error('Upload Error:', err);
      });
  };

  return (
    <div className="" style={{ padding: '20px' }}>
      <div className="d-flex align-items-start flex-wrap gap-3">
        <BlankHorizontalForm
          token={token}
          link={link}
          values={values}
          inputs={inputs}
          setInputs={setInputs}
          setReportHeader={setReportHeader}
          setReportFooter={setReportFooter}
          setData={setData}
          setValues={setValues}
          setIsModalOpen={setIsModalOpen}
          handleUploadToServer={handleUploadToServer}
          handleFileUploadChange={handleFileUploadChange}
          uploadLoading={loading}
          lableVisible={true}
          pageTitleVisibale={true}
        />

        {link?.columns && (
          <div>
            <h1>Upload Notice</h1>
            <p className="text-danger">
              Please only upload .csv file, before upload check your csv columns
              same as like this table
            </p>
            <table className="table table-bordered">
              <thead>
                <tr>
                  {/* Loop through the array and create a <th> for each */}
                  {link?.columns
                    ?.split(',')
                    .map((header) => header.trim())
                    .filter((header) => !Object.keys(values).includes(header))
                    .map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {/* Loop through the array and create a <th> for each */}
                  {link?.columns
                    ?.split(',')
                    .map((header) => header.trim())
                    .filter((header) => !Object.keys(values).includes(header))
                    .map((header, index) => (
                      <td key={index}>--</td>
                    ))}
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>

      {errorRecords && errorRecords.length > 0 && (
        <>
          <h2>
            ❌ Failed Uploads -{' '}
            <CSVLink
              data={errorRecords}
              filename={link?.table_name + '-error.csv'}
              className="btn btn-danger mr-2"
            >
              Export CSV
            </CSVLink>
          </h2>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  {Object.keys(errorRecords[0]).map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                  <th>Error Message</th>
                </tr>
              </thead>
              <tbody>
                {errorRecords.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((val, idx) => (
                      <td key={idx}>{val}</td>
                    ))}
                    <td>{row.error}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {successRecords && successRecords.length > 0 && (
        <>
          <h2>
            ✅ Successfully Uploads -{' '}
            <CSVLink
              data={successRecords}
              filename={link?.table_name + '-success.csv'}
              className="btn btn-success mr-2"
            >
              Export CSV
            </CSVLink>
          </h2>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  {Object.keys(successRecords[0]).map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {successRecords.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((val, idx) => (
                      <td key={idx}>{val}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {csvData && csvData.length > 0 && (
        <>
          <h2>CSV Preview</h2>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  {Object.keys(csvData[0]).map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {csvData.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((val, idx) => (
                      <td key={idx}>{val}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default CSVUploader;
